import React, { useCallback, useEffect, useState } from 'react';
import FavoriteIcon from '../../../../elements/icons/FavoriteIcon/FavoriteIcon';
import Link from '../../../../elements/Link';

const FavoriteDirectoryItem = (props) => {
    const { eventId, item } = props,
        { id, is_favorite } = item,
        [isFavorite, setFavorite] = useState(is_favorite);

    useEffect(() => {
        setFavorite(is_favorite);
    }, [is_favorite]);

    const handleToggleFavorite = useCallback(() => {
        const nextIsFavorite = !isFavorite;
        app.api.directory.toggleFavorite(eventId, id, nextIsFavorite);

        if (nextIsFavorite) {
            if (item.presentations) {
                for (let presentation of item.presentations) {
                    app.api.program.favoriteSession(eventId, presentation.program.id);
                    app.api.participants.toggleFavorite(presentation.speaker, true, eventId);
                }
            }
        }

        setFavorite(!isFavorite);
    }, [eventId, id, item, isFavorite]);

    return (
        <Link onClick={handleToggleFavorite}>
            <FavoriteIcon active={isFavorite} />
        </Link>
    );
};

export default FavoriteDirectoryItem;
